import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入axios
import axios from 'axios'

// import Vconsole from 'vconsole'

// new Vconsole()

Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.prototype.axios = axios;
// 引入rem
import './utils/rem'

// import('vconsole').then(({ default: VConsole }) => {
//   new VConsole({ theme: 'light' }) // dark深色 / light浅色
// })

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
